"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const u=(r,e,...o)=>{if(!e)throw new TypeError("pipe requires at least one function");return o.reduce((t,n)=>n(t),e(r))};exports.flow=u;
